__turbopack_context__.v({
  "handwritten": "_3q5D_G_handwritten",
});
